import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { CloudinaryImage } from "../../../../Atoms/Cloudinary";
import styles from "./CharterReasons.module.scss";

const charterReasons = [
  {
    imgSrc:
      "https://res.cloudinary.com/dbm1qiew0/image/upload/v1738036974/charter-assets/kdzblrd5mpzod8xdziae.png",
    title: "Private vehicle with hotel pickup",
    description:
      "Travel in comfort with a private, air-conditioned vehicle and hotel pickup.",
  },
  {
    imgSrc:
      "https://res.cloudinary.com/dbm1qiew0/image/upload/v1738036974/charter-assets/ptxc5kfkc0duhwhbr6su.png",
    title: "Dedicated tour guide with you throughout the tour",
    description:
      "Unlike typical tours with just a driver, our dedicated guide enriches every stop with insightful commentary, multiplying your enjoyment tenfold!",
  },
  {
    imgSrc:
      "https://res.cloudinary.com/dbm1qiew0/image/upload/v1738036974/charter-assets/klamlijhpac8iue0toul.png",
    title: "All-Inclusive Tours No hidden costs",
    description:
      "Forget about hidden fees; our tours cover everything from transportation to meals, unique experiences, and beyond, ensuring a worry-free adventure.",
  },
];

const CharterReasonCard = ({
  imgSrc,
  title,
  description,
}: {
  imgSrc: string;
  title: string;
  description: string;
}) => (
  <div className={styles.CharterReason}>
    <div className={styles.CharterImageContainer}>
      <CloudinaryImage src={imgSrc} transformations={["h_146"]} />
    </div>
    <div className={styles.CharterReasonText}>
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  </div>
);

export default function CharterReasons() {
  return (
    <section>
      <p className="DetailTitle" style={{ textAlign: "center", marginTop: 30 }}>
        Why Choose MagicalTrip&apos;s Chartered Private Tours?
      </p>

      <div className={styles.CharterReasonMobile}>
        <Swiper pagination={{ dynamicBullets: true }} modules={[Pagination]}>
          {charterReasons.map((reason, index) => (
            <SwiperSlide key={index}>
              <CharterReasonCard {...reason} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className={styles.CharterReasonContainer}>
        {charterReasons.map((reason, index) => (
          <CharterReasonCard key={index} {...reason} />
        ))}
      </div>
    </section>
  );
}
